/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RandomPromoAction } from './RandomPromoAction'
import {
  RandomPromoActionFromJSON,
  RandomPromoActionFromJSONTyped,
  RandomPromoActionToJSON,
} from './RandomPromoAction'

/**
 *
 * @export
 * @interface CreateRandomPromoAction200Response
 */
export interface CreateRandomPromoAction200Response {
  /**
   *
   * @type {boolean}
   * @memberof CreateRandomPromoAction200Response
   */
  status: boolean
  /**
   *
   * @type {RandomPromoAction}
   * @memberof CreateRandomPromoAction200Response
   */
  data: RandomPromoAction
}

/**
 * Check if a given object implements the CreateRandomPromoAction200Response interface.
 */
export function instanceOfCreateRandomPromoAction200Response(
  value: object
): value is CreateRandomPromoAction200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CreateRandomPromoAction200ResponseFromJSON(
  json: any
): CreateRandomPromoAction200Response {
  return CreateRandomPromoAction200ResponseFromJSONTyped(json, false)
}

export function CreateRandomPromoAction200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateRandomPromoAction200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: RandomPromoActionFromJSON(json['data']),
  }
}

export function CreateRandomPromoAction200ResponseToJSON(
  value?: CreateRandomPromoAction200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: RandomPromoActionToJSON(value['data']),
  }
}
